import { tanStackTableFilterOption } from 'reducers/tanStackTable';

export const ALL_FILTER_VALUE = '';
export const ORDERS_TAB = '0';
export const QUOTES_TAB = '1';

export const ORDER_STATUS_FILTER_OPTIONS: tanStackTableFilterOption[] = [
  { label: 'Confirmed', value: 'Confirmed' },
  { label: 'Canceled', value: 'Canceled' },
  { label: 'Pending Confirmation', value: 'Pending Confirmation' }
];

export const QUOTE_STATUS_FILTER_OPTIONS: tanStackTableFilterOption[] = [
  { label: 'In Progress', value: 'In Progress' },
  { label: 'Pending', value: 'Pending' },
  { label: 'Expired', value: 'Expired' }
];
